// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__tyMc5","label":"CheckBox_label__-SrN-","checkbox--active":"CheckBox_checkbox--active__TLHiS"};